import { z } from 'zod';

export const bidLineSchema = z.object({
  lineId: z.string(),
  itemId: z.string(),
  itemName: z.string(),
  sku: z.string(),
  quantity: z.number(),
  unit: z.string(),
  unitPrice: z.number(),
  totalPrice: z.number(),
  deliveryDate: z.string().optional(),
  notes: z.string().optional(),
});

export const bidSchema = z.object({
  bidId: z.string(),
  eventId: z.string(),
  eventNumber: z.string(),
  eventTitle: z.string(),
  supplierId: z.string(),
  supplierName: z.string(),
  status: z.enum(['draft', 'submitted', 'under_review', 'accepted', 'rejected', 'withdrawn', 'outbid']),
  lines: z.array(bidLineSchema),
  subtotal: z.number(),
  tax: z.number(),
  total: z.number(),
  currency: z.string(),
  rank: z.number().optional(),
  isLowestBid: z.boolean().optional(),
  deliveryTerms: z.string().optional(),
  validUntil: z.string().optional(),
  notes: z.string().optional(),
  submittedAt: z.string().optional(),
  reviewedBy: z.string().optional(),
  reviewedByName: z.string().optional(),
  reviewedAt: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type Bid = z.infer<typeof bidSchema>;
export type BidLine = z.infer<typeof bidLineSchema>;
export type BidStatus = Bid['status'];

export const bidsResponseSchema = z.object({
  data: z.array(bidSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number(),
  }),
});

export type BidsResponse = z.infer<typeof bidsResponseSchema>;

export const BID_STATUS_LABELS: Record<BidStatus, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  under_review: 'Under Review',
  accepted: 'Accepted',
  rejected: 'Rejected',
  withdrawn: 'Withdrawn',
  outbid: 'Outbid',
};

export const BID_STATUS_COLORS: Record<BidStatus, string> = {
  draft: 'bg-gray-100 text-gray-800',
  submitted: 'bg-blue-100 text-blue-800',
  under_review: 'bg-amber-100 text-amber-800',
  accepted: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
  withdrawn: 'bg-gray-100 text-gray-600',
  outbid: 'bg-orange-100 text-orange-800',
};
